import type { CommandRegistry } from '../../types/commands'
import { helpCommand } from './help'
import { aboutCommand } from './about'
import { projectsCommand } from './projects'
import { skillsCommand } from './skills'
import { experienceCommand } from './experience'
import { contactCommand } from './contact'
import { blogCommand } from './blog'
import { clearCommand } from './clear'
import { themeCommand } from './theme'
import { lsCommand } from './ls'
import { catCommand } from './cat'
import { cdCommand } from './cd'
import { pwdCommand } from './pwd'
import { touchCommand } from './touch'
import { mkdirCommand } from './mkdir'
import { rmCommand } from './rm'
import { echoCommand } from './echo'
import { settingsCommand } from './settings'
import { tutorialCommand } from './tutorial'
import { storyCommand } from './story'
import { valuesCommand } from './values'
import { easterEggCommands } from './easterEggs'

export const commandRegistry: CommandRegistry = {
  help: helpCommand,
  about: aboutCommand,
  projects: projectsCommand,
  skills: skillsCommand,
  experience: experienceCommand,
  contact: contactCommand,
  blog: blogCommand,
  clear: clearCommand,
  theme: themeCommand,
  ls: lsCommand,
  cat: catCommand,
  cd: cdCommand,
  pwd: pwdCommand,
  touch: touchCommand,
  mkdir: mkdirCommand,
  rm: rmCommand,
  echo: echoCommand,
  settings: settingsCommand,
  tutorial: tutorialCommand,
  story: storyCommand,
  values: valuesCommand,
  ...easterEggCommands,
}

export { CommandParser } from '../CommandParser'
